import styled from 'styled-components';
import UserInitials from '@/trio-ui/UserInitials';
import StatusTag from '../StatusTag';

export type BorderVariation = 'shadow' | 'solid';

export const Box = styled.div<{ border?: BorderVariation }>`
  background: ${({ theme }) => theme.colors['neutral-0']};
  ${({ border, theme }) =>
    border !== undefined &&
    `
    border: 1px solid ${theme.colors['neutral-30']};
    border-radius: 8px;
  `}
  ${({ border }) => border === 'shadow' && 'box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.07);'}
  padding: 8px;
  display: flex;
  cursor: pointer;
  transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  ${({ border }) =>
    border === 'shadow' &&
    `
    &:hover {
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
      transform: scale(1.005);
    }
  `}
`;

export const Thumbnail = styled(UserInitials)`
  margin-right: 12px;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 16px;
`;

export const InfoBox = styled.div`
  flex-grow: 1;
`;

export const TitleContainer = styled.div<{ withSourceInfo?: boolean }>`
  display: flex;
  align-items: ${({ withSourceInfo }) => (withSourceInfo ? 'center' : 'flex-start')};
  margin-bottom: ${({ withSourceInfo }) => (withSourceInfo ? 4 : 8)}px;
`;

export const Title = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: ${({ theme }) => theme.colors['primary-60']};
  display: inline-block;
`;

export const Tag = styled(StatusTag)`
  &:not(:first-child) {
    margin-left: 8px;
  }

  & > p {
    display: block;
    height: auto;
    border-radius: 4px;
    padding: 0;

    & > span {
      font-weight: 600;
      font-size: 12px;
      line-height: 16px !important;
      padding: 1px 5px;
    }

    .displayed {
      margin: 0;
    }
  }
`;

export const TechnologiesList = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
  flex-wrap: wrap;

  > p {
    padding: 3px 6px;
    background: ${({ theme }) => theme.colors['neutral-30']};
    border-radius: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${({ theme }) => theme.colors['neutral-100']};
  }
`;

export const Managerinfo = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${({ theme }) => theme.colors['neutral-100']};

  > p {
    display: inline-block;

    &::before {
      content: '|';
      margin-left: 12px;
      margin-right: 12px;
    }
  }
`;

export const MenuBox = styled.div`
  margin-left: 16px;
  align-self: center;
`;
